import React from 'react';

const ScreenLargeSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M3 18h18v-2H3v2zm0-3h18V8H3v7zm0-8h18V4H3v3zM2 3v16h9.5v2H9v1h6v-1h-2.5v-2H22V3H2z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M11 5h2v1h-2z"
        />
    </svg>
);

ScreenLargeSvg.displayName = 'ScreenLargeSvg';
export default ScreenLargeSvg;
